/*!
* Promotion footer block
*/

const wrap = '.promotion';
const closeElem = '.close-icon';

/**
 * Init subscribe form
 */
let init = () => {
    $(closeElem, wrap).on('click', (e) => {
        e.preventDefault();
        $(wrap).hide();
    });
};

export {init as initPromotion};
